export default "__VITE_ASSET__D3gP99Tz__"